import { render } from "./PayPassword.vue?vue&type=template&id=798abd14&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=798abd14&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=798abd14&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798abd14"]])

export default __exports__